module.exports = __webpack_public_path__ + "img/coupon_bg_popup_1.5ca8c97.png";